import { render, staticRenderFns } from "./CannotAddWidgetAlert.vue?vue&type=template&id=55931a2e&"
import script from "./CannotAddWidgetAlert.vue?vue&type=script&lang=js&"
export * from "./CannotAddWidgetAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports